(() => {
  const currency = window.ShopifyDL?.currency || 'EUR';
  const cartUrl = window.ShopifyDL?.cartUrl || '/cart.js';

  const pushEcommerce = (eventName, ecommerce) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: eventName, ecommerce });
  };

  const money = (cents) => Number(((Number(cents) || 0) / 100).toFixed(2));

  const toItem = (line) => ({
    item_id: String(line.sku || line.variant_id || line.id || ''),
    item_name: line.product_title || line.title || '',
    item_brand: line.vendor || '',
    item_category: line.product_type || '',
    item_variant: line.variant_title || '',
    price: money(line.final_price || line.price),
    quantity: Number(line.quantity) || 1,
  });

  const lineKey = (line) => String(line.key || line.variant_id || line.id);

  const cartMap = (cart) => {
    const map = new Map();
    (cart?.items || []).forEach((line) => map.set(lineKey(line), line));
    return map;
  };

  const cartValue = (cart) => money(cart?.total_price);

  let previousCart = { items: [], total_price: 0, item_count: 0 };
  let cartReady = false;

  const fetchCart = async () => {
    const response = await fetch(cartUrl, { headers: { Accept: 'application/json' } });
    if (!response.ok) return previousCart;
    return response.json();
  };

  const diffAndPush = (nextCart) => {
    if (!cartReady) {
      previousCart = nextCart;
      cartReady = true;
      return;
    }

    const prev = cartMap(previousCart);
    const next = cartMap(nextCart);
    const added = [];
    const removed = [];

    next.forEach((line, key) => {
      const before = prev.get(key);
      const qty = Number(line.quantity) || 0;
      const prevQty = Number(before?.quantity) || 0;
      const delta = qty - prevQty;
      if (delta > 0) added.push({ ...line, quantity: delta });
      if (delta < 0) removed.push({ ...line, quantity: Math.abs(delta) });
    });

    prev.forEach((line, key) => {
      if (!next.has(key)) removed.push(line);
    });

    if (added.length) {
      pushEcommerce('add_to_cart', {
        currency,
        value: added.reduce((sum, line) => sum + money(line.final_price || line.price) * line.quantity, 0),
        items: added.map(toItem),
      });
    }

    if (removed.length) {
      pushEcommerce('remove_from_cart', {
        currency,
        value: removed.reduce((sum, line) => sum + money(line.final_price || line.price) * line.quantity, 0),
        items: removed.map(toItem),
      });
    }

    previousCart = nextCart;
  };

  const checkoutFromCart = (cart) => {
    if (!cart?.items?.length) return;
    pushEcommerce('begin_checkout', {
      currency,
      value: cartValue(cart),
      items: cart.items.map(toItem),
    });
  };

  document.addEventListener('cart:update', async (event) => {
    if (event?.detail?.data?.didError) return;
    try {
      const cart = event?.detail?.resource?.items ? event.detail.resource : await fetchCart();
      diffAndPush(cart);
    } catch (error) {
      console.warn('[MiniLoop dataLayer]', error);
    }
  });

  document.addEventListener(
    'click',
    (event) => {
      const checkoutEl = event.target.closest('[href*="/checkout"], [name="checkout"], [type="submit"][name="checkout"]');
      if (checkoutEl) {
        checkoutFromCart(previousCart);
        return;
      }

      const cardLink = event.target.closest('product-card a[href*="/products/"]');
      if (!cardLink) return;
      const card = cardLink.closest('product-card');
      if (!card) return;

      pushEcommerce('select_item', {
        item_list_id: window.ShopifyDL?.collection || window.ShopifyDL?.pageType,
        item_list_name: window.ShopifyDL?.collection || document.title,
        items: [
          {
            item_id: card.getAttribute('data-product-id') || '',
            item_name: card.querySelector('[data-product-title], .product-card__title, .product-title')?.textContent?.trim() || cardLink.getAttribute('aria-label') || '',
            item_category: card.getAttribute('data-filter-prodotti') || '',
            item_brand: card.getAttribute('data-filter-marca') || '',
            item_variant: card.getAttribute('data-filter-taglia') || '',
          },
        ],
      });
    },
    true
  );

  fetchCart()
    .then((cart) => {
      previousCart = cart;
      cartReady = true;
    })
    .catch(() => {
      cartReady = true;
    });
})();
